import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { Notification, NotificationTranslations, updateNotifications } from 'ah-api-gateways';

/**
 * Notification component
 *
 * TODO: currently `view-resource` event is only triggered for custom-created software update notification, to allow opening modal
 */


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationCard',
  props: {
    notification: null
  },
  emits: ["mark-as-read", "view-resource"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'mark-as-read', notification: Notification): void;
  (e: 'view-resource', notification: Notification): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { notification: Notification };





const notificationTitle = computed(
  () => props.notification.title || NotificationTranslations[props.notification.type] || 'N/A'
);

const isSoftwareUpdate = computed(() => updateNotifications.includes(props.notification.type));

function markAsRead() {
  emit('mark-as-read', props.notification);
}

function viewResource() {
  emit('view-resource', props.notification);
}

return { __sfc: true,props, emit, notificationTitle, isSoftwareUpdate, markAsRead, viewResource }
}

})